// src/app/app.routes.ts
import { Routes } from '@angular/router';
// import { canDeactivateSupportPage } from './providers/can-deactivate-support.guard';
import { inject } from '@angular/core';
import { AuthService } from './services/auth/auth.service';

export const routes: Routes = [
  // ✅ better startup: go to login, autoLoginGuard will forward to /app if session exists
  { path: '', redirectTo: '/login', pathMatch: 'full' },

  // ✅ Upgrade page accessible for logged-in sessions (phone or email)
  {
    path: "upgrade-auth",
    canActivate: [async () => await inject(AuthService).authGuard()],
    loadComponent: () =>
      import("./pages/upgrade-auth/upgrade-auth.page").then((m) => m.UpgradeAuthPage),
  },

  {
    path: 'app',
    loadChildren: () => import('./pages/tabs/tabs.routes').then((m) => m.routes),
    canMatch: [
      async () => await inject(AuthService).authGuard(),
      async () => await inject(AuthService).upgradeGuard(), // ✅ blocks app until upgraded
    ],
    data: { type: 'user' }
  },

  {
    path: 'support',
    loadComponent: () => import('./pages/support/support').then(m => m.SupportPage),
    // canDeactivate: [canDeactivateSupportPage],
  },

  // ✅ IMPORTANT: use canActivate (NOT canMatch) to avoid redirect loops
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/auth.page').then(m => m.AuthPage),
    canActivate: [
      async () => await inject(AuthService).autoLoginGuard(),
      async () => await inject(AuthService).introGuard(),
    ],
  },

  {
    path: 'tutorial',
    loadComponent: () => import('./pages/tutorial/tutorial').then(m => m.TutorialPage),
  },

  {
    path: 'privacy',
    loadComponent: () => import('./pages/privacy/privacy.page').then(m => m.PrivacyPage)
  },

  {
    path: 'delete-account',
    loadComponent: () => import('./pages/delete-account/delete-account').then(m => m.DeleteAccountPage),
  },

  { path: '**', redirectTo: '/login' },
];
